import React from "react";

const Cart = () => {
  return (
    <div style={{ textAlign: "center", fontSize: "30px", marginTop: "30px" }}>
      No Items Added To Cart! Come Back Soon.{" "}
      <a href="/">Return To Main page</a>
    </div>
  );
};

export default Cart;
